import React, { useContext } from 'react';
import { styled } from 'styled-components';

import { CookieBanner } from './Cookie';
import { ExternalPageContext } from './ExternalPageContext';
import { LayoutFooter } from './LayoutFooter';
import { PreviewHeaderLayout } from './LayoutHeader';
import { LayoutBackground } from './components';

const Main = styled.main`
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  padding: 19px 21px;
  overflow: auto;

  ${p =>
    p.theme.isMobile &&
    `
    padding-top: 45px;
    padding-right: 28px;
    padding-left: 28px;
    `}
`;

interface PreviewLayoutProps {
  children: React.ReactNode;
}

export const PreviewLayout = (props: PreviewLayoutProps) => {
  const { children } = props;
  const { external } = useContext(ExternalPageContext);

  return (
    <LayoutBackground>
      <PreviewHeaderLayout />
      <Main>{children}</Main>
      {!window.env.FOOTER_DISABLED && <LayoutFooter />}
      {!external && <CookieBanner />}
    </LayoutBackground>
  );
};
